module.exports = __webpack_public_path__ + "img/icon-prohibited_a.7d929932.svg";